<script setup lang="ts">
import {computed} from 'vue'
import { useOrgStore } from '@/stores/org'

import {formatTime} from '@/utils/datetime'
import { MoreHorizontal } from 'lucide-vue-next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { isOwnerOrSuperUser } from '@/composables/useCan'


const orgStore = useOrgStore()
const props = defineProps<{
  apikey: any
}>()

const remove = (ev: any) => {
  orgStore.removeApiKey(props.apikey)
}
</script>

<template>
  <DropdownMenu v-if="isOwnerOrSuperUser(apikey.organization_id)">
    <DropdownMenuTrigger as-child>
      <Button variant="ghost" class="w-8 h-8 p-0">
        <span class="sr-only">Open</span>
        <MoreHorizontal class="w-4 h-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem @click="remove" class="text-red-500">Delete</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
